import React, { useContext, Fragment, useState, useEffect } from 'react'
import moment from 'moment'

/* package */
import { SectionWrappListItem } from '../../lib-atomic-section'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import { WindowSize } from '../../lib-atomic-functions'
import { GlobalContext } from '../../lib-atomic-context'
/* package */

/* modules */
import CONFIG from '../config'

import SectionContentFilter from '../../app-filter-section-select-campaign/default'
import SectionContentImage from '../../app-content-section-image/default'

/* CONSTANTS */

// const CMSMASTERSETUPCONFIG = {
//   url: CMSENDPOINTS.updatemastersetup.url,
//   method: CMSENDPOINTS.updatemastersetup.method,
//   headers: CMSENDPOINTS.updatemastersetup.headers,
//   responseType: "json",
// };
/* CONSTANTS */

const useStyles = makeStyles((theme) => ({
  root: {
    '&:hover': {
      cursor: 'pointer',
    },
    height: 140,
  },
  upper: {
    textTransform: 'uppercase',
  },
  camel: {
    textTransform: 'capitalize',
  },
}))

const formatDate = (from, to) => {
  return {
    formattedFrom:
      from !== null && from !== ''
        ? moment(from).format('DD-MMM-YYYY  HH:mm:ss')
        : 'Not set',
    formattedTo:
      to !== null && to !== ''
        ? moment(to).format('DD-MMM-YYYY  HH:mm:ss')
        : 'Not set',
  }
}
const Index = (props) => {
  const { width, height } = WindowSize()
  const classes = useStyles()
  const { contents, campaignlist } = useContext(GlobalContext)

  const [rawContent, setRawContent] = useState([])
  const [filteredContent, setFilteredContent] = useState([])

  useEffect(() => {
    const mastercampaign = campaignlist.state.data
    setRawContent(mastercampaign)
    setFilteredContent(mastercampaign)
  }, [])

  const handleToDetail = ({ id }) => {
    props.history.push('/campaign/detail/' + id)
  }

  // data props
  const filterProps = {
    ...props,
    rawContent,
    filteredContent,
    setFilteredContent,
  }
  // data props

  return (
    <Fragment>
      <SectionContentFilter {...filterProps} />
      {filteredContent.map((campaign, index) => {
        console.log(campaign)
        const {
          id,
          name,
          publishFrom,
          publishTo,
          questions,
          mastercountries,
          masterlanguages,
          mastercontents,
          campaignType,
          campaignCode,
        } = campaign
        const { formattedFrom, formattedTo } = formatDate(
          publishFrom,
          publishTo
        )

        const { homeImage } = mastercontents ? mastercontents : {}
        const imageData = {
          images: [{ name: null, img: homeImage }],
          size: 'small',
        }

        return (
          <SectionWrappListItem
            key={index}
            noOfCol={width < 820 ? 12 : width < 1150 ? 6 : 3}
            customStyle={{
              cursor: 'pointer',
              overflow: 'auto',
              display: 'block',
            }}
            onClickFunc={() => handleToDetail({ id })}
          >
            <Typography variant="body2">
              <small className={classes.upper}>
                <b>{mastercountries.abbr}</b>
              </small>
              &nbsp; / &nbsp;
              <small className={classes.camel}>
                <b>{masterlanguages.abbr}</b>
              </small>
            </Typography>
            <SectionContentImage {...imageData} />
            <div className={classes.root}>
              <Typography variant="body2">
                <b>
                  #{id}&nbsp;{name}&nbsp;({campaignType})
                </b>
              </Typography>
              <Typography variant="body2">
                <small>
                  <span>Publish From</span> <br />
                  <b>&nbsp;&nbsp;{formattedFrom}</b>
                </small>
                <br />
                <small>
                  <span>Publish To</span> <br />
                  <b>&nbsp;&nbsp;{formattedTo}</b>
                </small>
              </Typography>
              {/* <Typography variant="body2">
                <small>
                  <span>Title</span> <br />
                  <b>&nbsp;&nbsp;{title}</b>
                </small>
              </Typography> */}
            </div>
          </SectionWrappListItem>
        )
      })}
    </Fragment>
  )
}

export default Index
